import { getFormattedSlug } from '@src/pages/[...slug]/components/collection/utils'

import isBrowser from './isBrowser'

export const getPathName = (slug: string) => {
  return slug ? `/${getFormattedSlug(slug).toString().split(' ').join('-').toLowerCase()}` : '/'
}

export const getPathNameFromWindow = () => {
  if (isBrowser()) {
    return window?.location?.pathname
  }
  return undefined
}
